import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

import { Box, Flex, useToast } from '@chakra-ui/react'
import { MdUnpublished } from "react-icons/md";
import { resetUpdatePdsrOutcome, updatePdsr } from '../../actions/dsr-actions'
import PageLoader from '../../../global/components/helper-components/components/PageLoader'
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton'
import { redirectToNewPage, triggerLaunchdeckToast } from '../../../global/helpers/global-helpers'
import LaunchdeckModal from '../../../global/components/helper-components/components/LaunchdeckModal'



function ProspectDsrCardUnpublishModal({
  modalTransferPayload,
  handleCloseModal,
  updatePdsr,
  updateProspectDsrOutcome,
  resetUpdatePdsrOutcome,
  isMobileView
}) {

  const toast = useToast();
  const { pDsrId, dsrTitle } = modalTransferPayload || {}
  const [showLoader, setShowLoader] = useState(false)

  useEffect(() => {
    if (updateProspectDsrOutcome) {
      const { updatePdsrStatus, updatedPdsrId, sourceEvent } = updateProspectDsrOutcome || {};

      if (updatePdsrStatus && updatedPdsrId && sourceEvent === "unpublish-prospector-dsr") {
        redirectToNewPage(`/draft/pdsr/${updatedPdsrId}`)
      } else if (updatePdsrStatus !== "success") {
        toast(
          triggerLaunchdeckToast({
            useCase: "show-error-state",
            label: "Unfortunately something went wrong. Please unpublish it from the Settings page.",
            isMobileView
          })
        )

        setShowLoader(false)
        resetUpdatePdsrOutcome()
        handleCloseModal()
      }

    }
  }, [updateProspectDsrOutcome]);

  const handleClickUnpublishButton = () => {
    setShowLoader(true);
    updatePdsr({
      pDsrId,
      sourceEvent: "unpublish-prospector-dsr",
      status: 'reverted-draft'
    })
  }

  function displayContent() {
    if (showLoader) {
      return (
        <Box w="100%" align="center" >
          <Box px='1em'>
            <PageLoader />
          </Box>
        </Box>
      )
    }

    if (!showLoader) {
      return (
        <Box w='100%' p='1em 1.8em'>
          <Flex w="100%" fontSize='0.875em' color='brandDark.500'>
            This Prospector will become inactive while unpublished. Proceed?
          </Flex>

          <Flex mt='1.625em' w='100%' justify={['center', 'flex-end']}>
            <LaunchdeckButton bg='brandPink.500' w={['100%', 'auto']} color='gray.50' fontSize='0.8em' py='0.4em' onClick={() => handleClickUnpublishButton()} label='Yes, unpublish' />
          </Flex>
        </Box>
      )
    }
  }

  return (
    <LaunchdeckModal
      title={
        <Flex align='center' gap='0.5em'>
          <Box as={MdUnpublished} color='brandPink.500'
            boxSize="1.6em" />
          <Box py='0.5em' color='white'>Unpublish {dsrTitle ? <i>{dsrTitle}</i> : "this Prospector"}</Box>
        </Flex>
      }
      handleCloseModal={() => handleCloseModal()}
      showModal={true}
      maxW='35em'
    >
      {displayContent()}
    </LaunchdeckModal>
  )
}

function mapStateToProps(state) {
  return {
    updateProspectDsrOutcome: state.updateProspectDsrOutcome.results.data,
    isMobileView: state.mobileViewMode.isMobileView
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updatePdsr,
      resetUpdatePdsrOutcome
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProspectDsrCardUnpublishModal));
